<template>
  <component
    v-if="order === false"
    :animation-duration="1000"
    :is="'FingerprintSpinner'"
    :color="$themes.primary"
    :size="200"
    class="loading"
  >
  </component>
  <div v-else>
    <va-card>
      <div class="row">
        <div class="flex md6 xs12">
          <va-card class="chart-widget card" :title="$t('order.client')">
            <ul>
              <li>
                <strong>Name: </strong>
                <router-link
                  :to="{
                    name: 'orders-search',
                    params: {
                      search: order.first_name + ' ' + order.last_name,
                    },
                  }"
                >{{ order.first_name + ' ' + order.last_name }}</router-link
                >
              </li>
              <li>
                <strong>IP:</strong>
                <router-link
                  :to="{
                    name: 'orders-search',
                    params: { search: order.customer_ip },
                  }"
                >{{ order.customer_ip }}</router-link
                >
              </li>
              <li>
                <strong>Email:</strong>
                <router-link
                  :to="{
                    name: 'orders-search',
                    params: { search: order.email },
                  }"
                >{{ order.email }}</router-link
                >
              </li>
            </ul>
          </va-card>
          <va-card class="chart-widget" :title="$t('order management')">
            <div
              class="status-info"
              :class="'bg-' + getColorStatus(order.status) + ' ' + order.status">
            </div>
            <div class="order-status">
              <strong>Status:</strong>
              <va-select
                v-model="order.status"
                :placeholder="order.status"
                :options="OrderStatuses.filter((v, i, s) => s.indexOf(v) === i)"
                noClear
              />
            </div>
            <div class="addBanRule">
              <va-button @click="addBanRule" class="addBanRuleBtn">Add ban rule</va-button>
            </div>
          </va-card>
        </div>
        <div class="flex md6 xs12">
          <va-card class="chart-widget" :title="$t('order.info')">
            <ul>
              <li>
                <strong>Internal ID:</strong>
                <span>{{ order.id }}</span>
              </li>
              <li>
                <template v-if="order.source_site">
                  <strong>
                    {{ order.source_site.domain_name }} ID:
                  </strong>
                  <span class="copy" @click="copy('copyTextOrder_id')">
                    {{ order.order_id }}
                    <i class="va-icon material-icons" style="font-size: 30px;">
                      content_copy
                    </i>
                  </span>
                  <input
                    type="text"
                    :value="order.order_id"
                    ref="copyTextOrder_id"
                  />
                </template>
              </li>
              <li>
                <strong>Total:</strong>
                <span>${{ order.amount }}</span>
              </li>
              <li v-if="order.payment_method">
                <strong>Payment method:</strong>
                <span>{{ order.payment_method.name }}</span>
              </li>
              <li v-else>
                <strong>Requested payment method:</strong>
                <span>
                  {{
                    order.requested_payment_method
                      ? order.requested_payment_method
                      : '-'
                  }}
                </span>
              </li>
              <li>
                <strong>Payment site:</strong>
                <span>{{
                  order.payment_method
                    ? order.payment_method.domain_name
                    : '-'
                }}</span>
              </li>
              <li>
                <strong>Is proxy:</strong>
                <span :class="{'proxy': order.is_proxy, 'not-proxy': order.is_proxy !== null && !order.is_proxy}">{{
                  order.is_proxy !== null
                    ? order.is_proxy
                    : '-'
                }}</span>
              </li>
              <li>
                <strong>Total orders:</strong>
                <span>{{ order.total_orders !== null ? order.total_orders : '-' }}</span>
              </li>
              <li>
                <strong>Date created:</strong>
                <span>
                  {{ parseDate(order.create_timestamp) }}
                </span>
              </li>
              <li>
                <strong>Last modified:</strong>
                <span>
                  {{ parseDate(order.last_change_timestamp) }}
                </span>
              </li>
            </ul>
          </va-card>
        </div>
      </div>
      <va-card class="card" :title="$t('order.products')">
        <va-data-table
          :fields="fieldsOrderItemsWoo"
          :data="order.items"
          no-pagination
        >
          <template slot="name" slot-scope="props">
            {{
              props.rowData.product
                ? props.rowData.product.service + ' ' + props.rowData.product.name
                : '-'
            }}
          </template>
          <template slot="target" slot-scope="props">
            <div v-if="!props.rowData.target">-</div>
            <template v-else>
              <div v-if="order.status === 'manual'">
                <span
                  class="copy"
                  @click="copy('copyTexttarget' + props.rowData.id)"
                >
                  {{ props.rowData.target }}
                  <i class="va-icon material-icons" style="font-size: 30px;" @click="editProductItem(props.rowData.id, props.rowData.target)">edit</i>
                </span>
                <input
                  type="text"
                  :value="props.rowData.target"
                  :ref="'copyTexttarget' + props.rowData.id"
                />
              </div>
              <div v-else>
                <span
                  class="copy"
                  @click="copy('copyTexttarget' + props.rowData.id)"
                >
                  {{ props.rowData.target }}
                  <i class="va-icon material-icons" style="font-size: 30px;"
                  >content_copy</i
                  ></span
                  >
                <input
                  type="text"
                  :value="props.rowData.target"
                  :ref="'copyTexttarget' + props.rowData.id"
                />
              </div>
            </template>
          </template>

          <template
            v-if="
              (props.rowData.status === 'pending' ||
                props.rowData.status === 'fail') &&
                order.status === 'manual'
            "
            slot="retry"
            slot-scope="props"
          >
            <va-button
              :ref="'product' + props.rowData.id"
              @click="retrySupProduct(props.rowData.id)"
            >retry</va-button
            >
          </template>
        </va-data-table>
      </va-card>

      <div v-if="ipns.length">
        <va-card class="mt-3 card" :title="$t('order ipns')">
          <div class="va-table-responsive" v-if="paypalIpns.length">
            <table class="va-table va-table--hoverable table-w-100">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Full name</th>
                  <th>Payer email</th>
                  <th>Address country</th>
                  <th>Address city</th>
                  <th>Address street</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ipn in paypalIpns" :key="ipn.id">
                  <td>{{ ipn.id }}</td>
                  <td>{{ ipn.data.payment_status }}</td>
                  <td>{{ ipn.data.first_name + ' ' + ipn.data.last_name }}</td>
                  <td>{{ ipn.data.payer_email }}</td>
                  <td>{{ ipn.data.address_country }}</td>
                  <td>{{ ipn.data.address_city }}</td>
                  <td>{{ ipn.data.address_street }}</td>
                  <td>{{ parseDate(ipn.create_timestamp) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="va-table-responsive mt-3" v-if="stripeIpns.length">
            <table class="va-table va-table--hoverable table-w-100">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Status</th>
                  <th>Billing name</th>
                  <th>Billing country</th>
                  <th>Billing postal code</th>
                  <th>Payment method details</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ipn in stripeIpns" :key="ipn.id">
                  <td>{{ ipn.id }}</td>
                  <td>{{ ipn.data.data.object.status }}</td>
                  <td>{{ ipn.data.data.object.billing_details.name }}</td>
                  <td>{{ ipn.data.data.object.billing_details.address.country }}</td>
                  <td>{{ ipn.data.data.object.billing_details.address.postal_code || '-' }}</td>
                  <td>
                    {{
                      ipn.data.data.object.payment_method_details.card.brand + ' / ' +
                        ipn.data.data.object.payment_method_details.card.last4
                    }}
                  </td>
                  <td>{{ parseDate(ipn.create_timestamp) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </va-card>
      </div>
      <div v-if="order.notifications.length">
        <va-card class="mt-3 card" :title="$t('order notifications')">
          <div class="va-table-responsive">
            <table class="va-table va-table--hoverable table-w-100">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Message</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="notification in order.notifications" :key="notification">
                  <td>{{ notification.id }}</td>
                  <td>{{ notification.text }}</td>
                  <td>{{ parseDate(notification.timestamp) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </va-card>
      </div>
      <div>
        <va-card class="mt-3 card" :title="$t('notes')">
          <div class="va-table-responsive" v-if="order.notes">
            <table class="va-table va-table--hoverable table-w-100">
              <thead>
                <tr>
                  <th>User</th>
                  <th>Message</th>
                  <th>Timestamp</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="note in notes" :key="note.id">
                  <td>{{ note.by }}</td>
                  <td>{{ note.text }}</td>
                  <td>{{ parseDate(note.timestamp) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex md5 mt-3">
            <form class="noteForm" @submit.prevent="addNote">
              <va-input type="textarea" v-model="noteMessage" required />
              <va-button type="submit">Send</va-button>
            </form>
          </div>
        </va-card>
      </div>
    </va-card>
  </div>
</template>

<script>
import { FingerprintSpinner } from 'epic-spinners'
import { debounce } from 'lodash'
import axios from 'axios'

export default {
  data () {
    return {
      orderSTATUS: '',
      order: false,
      ipns: false,
      notes: [],
      noteMessage: '',
    }
  },
  components: {
    FingerprintSpinner,
  },
  methods: {
    retrySupProduct (id) {
      this.$refs['product' + id].$el.disabled = true
      this.$refs['product' + id].$el.style.opacity = 0.5
      this.$store.dispatch('orderItemRetry', id)
    },
    async editProductItem (id, text) {
      const target = prompt('New target?', text)
      if (target !== null) {
        await this.$store.dispatch('updateOrderItem', { id, target })
        await this.$store.dispatch('searchOrders', this.$route.params.id)
        this.order = await this.$store.getters.Orders
      }
    },
    copy (input, isCollapp) {
      if ((this.$refs.collapp, isCollapp === 'collapp')) {
        this.$refs.collapp[0].toggle()
      }
      input = this.$refs[input][0] || this.$refs[input]
      input.select()
      input.setSelectionRange(0, 99999)
      document.execCommand('copy')
      return false
    },
    addNote (event) {
      const currentUser = JSON.parse(localStorage.getItem('user')).username
      const payload = {
        by: currentUser,
        order: this.$route.params.id,
        text: this.noteMessage,
      }
      axios
        .post(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/notes/`, payload)
        .then(({ data }) => {
          this.notes.unshift({
            by: data.by,
            text: data.text,
            timestamp: data.timestamp,
          })
        })
      this.noteMessage = ''
      event.target.reset()
    },
    addBanRule (event) {
      axios.post(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ban-rules/`, { email_pattern: this.order.email })
        .catch(error => { alert('Rule already exists!') })
      axios.post(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/ban-rules/`, { ip_address: this.order.customer_ip })
        .catch(error => { alert('Rule already exists!') })
    },
  },
  computed: {
    showColumnRetry () {
      return !!(
        this.order.items.find(
          i => i.status === 'fail' || i.status === 'pending',
        ) && this.order.status === 'manual'
      )
    },
    totalOrderProductsWoo () {
      return this.order.items.reduce(
        (accumulator, order) =>
          accumulator + order.quantity * order.product.price,
        0,
      )
    },
    fieldsOrderItemsWoo () {
      return [
        {
          name: 'id',
          title: this.$t('order.items.id'),
        },
        {
          name: '__slot:name',
          title: this.$t('order.items.name'),
        },
        {
          name: '__slot:target',
          title: 'Target',
        },
        {
          name: 'quantity',
          title: this.$t('order.items.quantity'),
        },
        {
          name: 'status',
          title: this.$t('order.items.status'),
        },
        {
          name: 'supplier_order_id',
          title: this.$t('order.items.supplier_order_id'),
        },
        {
          name: '__slot:retry',
          title: this.showColumnRetry ? 'retry' : '',
        },
      ]
    },
    OrderStatuses () {
      const toIgnore = ['failed', 'ignored', 'warn', 'disputed', 'refunded']
      return this.$store.getters.OrderStatuses.filter(e => !toIgnore.includes(e))
    },
    paypalIpns () {
      return this.ipns.filter(ipn => ipn.data && ipn.data.payer_email)
    },
    stripeIpns () {
      return this.ipns.filter(ipn => ipn.data && ipn.data.data)
    },
  },
  created () {
    this.$store.dispatch('searchOrders', this.$route.params.id).then(() => {
      this.order = this.$store.getters.Orders
    })
    this.$store
      .dispatch('getIpns', '?order=' + this.$route.params.id)
      .then(() => {
        this.ipns = this.$store.getters.Ipns
      })
    this.$store.dispatch('getOrderStatuses')
    axios.get(`${process.env.VUE_APP_EXTERNAL_ADDRESS}/v1/notes/?order__id=${this.$route.params.id}`)
      .then(({ data }) => { this.notes = data })
  },
  watch: {
    'order.status': debounce(function () {
      this.$store.dispatch('updateOrder', {
        status: this.order.status,
        id: this.order.id,
      })
    }, 500),
  },
}
</script>
<style lang="scss">
.logs {
  color: #34495e;
  font-weight: 600;
}

.order-status {
  max-width: 300px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  float: left;

  .va-select {
    margin-bottom: 0 !important;
  }

  strong {
    margin-right: 5px;
  }
}
</style>

<style lang="scss">
.ipn-html {
  ul {
    margin-left: 20px;
  }

  .has-children {
    position: relative;

    input:checked ~ .icon {
      &::before {
        content: '-';
      }
    }

    .icon {
      &::before {
        content: '+';
        position: absolute;
        top: -5px;
        font-weight: 700;
        left: -10px;
        color: black;
        display: block;
      }

      display: block;
      position: absolute;
      right: 100%;
      bottom: 0;
      top: 0;
      width: 1px;
      background: red;
    }

    strong {
      cursor: pointer;
    }

    ul {
      display: none;
    }

    input {
      display: none;
    }

    input:checked ~ ul {
      display: block;
    }
  }
}
</style>
<style lang="scss" scoped>
@each $name, $color in $theme-colors {
  @if $name == 'pale' {
    $name: 'gray';
  }

  .bg-#{$name} {
    background: $color;
  }
}

.card {
  margin-bottom: 20px;
}

.total-list-amount {
  display: block;
  max-width: max-content;
  margin-left: auto;
  margin-top: 10px;
}

.row-ipn {
  &-header {
    border-bottom: 2px solid #34495e;
  }

  color: black;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;

  li {
    flex-grow: 1;
  }
}

.chart-widget {
  position: relative;
  padding-bottom: 20px;

  .status-info {
    opacity: 0.6;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
  }
}

.copy {
  color: #34495e;
  cursor: pointer;

  input {
    position: absolute;
    transform: scale(0.01);
  }

  & + input {
    // opacity: 0;
    // display: none;
    position: absolute;
    transform: scale(0.01);
    // width: 0;
    // height: 0;
  }

  i {
    font-size: 15px !important;
    cursor: pointer;
  }
}

.loading {
  position: absolute;
  left: 50%;
  top: 50vh;
  transform: translate(-50%, -50%);
}

li {
  strong {
    display: inline-block;
    margin-right: 5px;
  }

  span {
    color: black;
  }
}

h2 {
  display: flex;
  text-align: end;
  justify-content: flex-end;

  strong {
    color: white;
    padding: 0 10px;
    margin-right: 10px;
  }
}

.ipns-list {
  display: flex;
  justify-content: space-between;
  align-content: center;
}

.table-w-100 {
  width: 100%;
}

.noteForm {
  display: flex;
  align-items: center;
}

.proxy {
  color: red;
}

.not-proxy {
  color: green;
}

.addBanRuleBtn {
  background-color: red !important;
}

.addBanRule {
  float: right;
}
</style>
